import lodash from 'lodash'

// version api
import VersionService from '@/api/VersionService'
// local storeage
import LocalStorage from 'store'
// A small, fast and rich-API browser/platform/engine detector for both browser and node.
import Bowser from 'bowser'
// router
import router from './../../router'
// store
import store from '../../store'
// transforms
import { transformPagination } from '@/transform/pagination'

// initial state
const state = {
  currentVersion: '1.26.0',
  latestVersion: null,
  loading: false,
  loadinglist: [],
  error_message: null,
  section: 'login', // login, home, app
  lang: 'th',
  sidebar: [],
  header_title: null,
  last_router: null,
  prev: {
    app_name: null,
    app_id: null,
  },
  current: {
    app_name: null,
    app_id: null,
    module_id: null,
    submodule_id: null,
  },
  uiOptions: { // default
    'sidebar': 'expanded',
    'status': {
      'newproduct': {
        'auto_gen_sku': false,
        'auto_copy_price': false,
        'auto_copy_cost': false,
      },
    },
  },
  network_status: true, // online return true, offline return false
  defaultImages: {
    'product': require('@/assets/images/items/no-image.png'),
  },
  limitRowsPerpage: 10, // table limit rows per pages
  pagination: transformPagination({}),
  apps: [
    {
      app_id: 1,
      translate: 'app.pos',
      modules: [
        {
          module_id: 1,
          translate: 'apps.settings.permission.appid1-moduleid1',
          learn_more_link: 'https://treesoft.io/th/manual/pos#dashboard',
        },
        {
          module_id: 5,
          translate: 'apps.settings.permission.appid1-moduleid5',
          learn_more_link: 'https://treesoft.io/th/manual/pos#menu-online',
        },
        {
          module_id: 2,
          translate: 'apps.settings.permission.appid1-moduleid2',
          learn_more_link: 'https://treesoft.io/th/manual/pos#transaction',
        },
        {
          module_id: 3,
          translate: 'apps.settings.permission.appid1-moduleid3',
          learn_more_link: 'https://treesoft.io/th/manual/pos#branch',
        },
        {
          module_id: 4,
          translate: 'apps.settings.permission.appid1-moduleid4',
          learn_more_link: 'https://treesoft.io/th/manual/pos#setting',
        },
      ],
    },
    // {
    //   app_id: 10,
    //   translate: 'app.ecommerce',
    //   modules: [],
    // },
    {
      app_id: 2,
      translate: 'app.products',
      modules: [
        {
          module_id: 1,
          translate: 'apps.settings.permission.appid2-moduleid1',
          learn_more_link: 'https://treesoft.io/th/manual/product#item',
        },
        {
          module_id: 2,
          translate: 'apps.settings.permission.appid2-moduleid2',
          learn_more_link: 'https://treesoft.io/th/manual/product#category',
        },
        {
          module_id: 4,
          translate: 'apps.settings.permission.appid2-moduleid4',
          learn_more_link: 'https://treesoft.io/th/manual/product#discount',
        },
        {
          module_id: 3,
          translate: 'apps.settings.permission.appid2-moduleid3',
          learn_more_link: 'https://treesoft.io/th/manual/product#modify',
        },
        {
          module_id: 6,
          translate: 'apps.settings.permission.appid2-moduleid6',
          learn_more_link: 'https://treesoft.io/th/manual/product#recipe',
        },
      ],
    },
    {
      app_id: 3,
      translate: 'app.inventory',
      modules: [
        {
          module_id: 1,
          translate: 'apps.settings.permission.appid3-moduleid1',
          learn_more_link: 'https://treesoft.io/th/manual/inventory#overview',
        },
        {
          module_id: 2,
          translate: 'apps.settings.permission.appid3-moduleid2',
          learn_more_link: 'https://treesoft.io/th/manual/inventory#stockcontrol',
        },
        {
          module_id: 3,
          translate: 'apps.settings.permission.appid3-moduleid3',
          learn_more_link: 'https://treesoft.io/th/manual/inventory#stockhistory',
        },
        {
          module_id: 4,
          translate: 'apps.settings.permission.appid3-moduleid4',
          learn_more_link: 'https://treesoft.io/th/manual/inventory#goods-receipt',
          group: 2, // next items from here
        },
        {
          module_id: 5,
          translate: 'apps.settings.permission.appid3-moduleid5',
          learn_more_link: 'https://treesoft.io/th/manual/inventory#goods-issue',
        },
        {
          module_id: 6,
          translate: 'apps.settings.permission.appid3-moduleid6',
          learn_more_link: 'https://treesoft.io/th/manual/inventory#goods-transfer',
        },
        {
          module_id: 7,
          translate: 'apps.settings.permission.appid3-moduleid7',
          learn_more_link: 'https://treesoft.io/th/manual/inventory#lot',
        },
        {
          module_id: 8,
          translate: 'apps.settings.permission.appid3-moduleid8',
          learn_more_link: 'https://treesoft.io/th/manual/inventory#serial',
        },
        {
          module_id: 9,
          translate: 'apps.settings.permission.appid3-moduleid9',
          learn_more_link: 'https://treesoft.io/th/manual/inventory#warehouse',
        },
        {
          module_id: 10,
          translate: 'apps.settings.permission.appid3-moduleid10',
          learn_more_link: 'https://treesoft.io/th/manual/inventory#setting',
        },
      ],
    },
    {
      app_id: 4,
      translate: 'app.purchases',
      modules: [
        {
          module_id: 3,
          translate: 'apps.settings.permission.appid4-moduleid3',
          learn_more_link: 'https://treesoft.io/th/manual/purchase#pr',
        },
        {
          module_id: 1,
          translate: 'apps.settings.permission.appid4-moduleid1',
          learn_more_link: 'https://treesoft.io/th/manual/purchase#po',
        },
        {
          module_id: 4,
          translate: 'apps.settings.permission.appid4-moduleid4',
          learn_more_link: 'https://treesoft.io/th/manual/expense#po-type',
        },
        {
          module_id: 2,
          translate: 'apps.settings.permission.appid4-moduleid2',
          learn_more_link: 'https://treesoft.io/th/manual/purchase#setting',
        },
      ],
    },
    {
      app_id: 5,
      translate: 'app.sales',
      modules: [
        {
          module_id: 1,
          translate: 'apps.settings.permission.appid5-moduleid1',
          learn_more_link: 'https://treesoft.io/th/manual/sale#so',
        },
        {
          module_id: 3,
          translate: 'apps.settings.permission.appid5-moduleid3',
          learn_more_link: 'https://treesoft.io/th/manual/expense#sale-type',
        },
        {
          module_id: 2,
          translate: 'apps.settings.permission.appid5-moduleid2',
          learn_more_link: 'https://treesoft.io/th/manual/sale#setting',
        },
      ],
    },
    {
      app_id: 6,
      translate: 'app.expenses',
      modules: [
        {
          module_id: 1,
          translate: 'apps.settings.permission.appid6-moduleid1',
          learn_more_link: 'https://treesoft.io/th/manual/expense#exp',
        },
        {
          module_id: 3,
          translate: 'apps.settings.permission.appid6-moduleid3',
          learn_more_link: 'https://treesoft.io/th/manual/expense#exp-type',
        },
        {
          module_id: 2,
          translate: 'apps.settings.permission.appid6-moduleid2',
          learn_more_link: 'https://treesoft.io/th/manual/expense#setting',
        },
      ],
    },
    {
      app_id: 14,
      translate: 'app.payroll',
      modules: [
        {
          module_id: 1,
          translate: 'apps.settings.permission.appid14-moduleid1',
          learn_more_link: 'https://treesoft.io/th/manual/payroll#payslip',
        },
        {
          module_id: 2,
          translate: 'apps.settings.permission.appid14-moduleid2',
          learn_more_link: 'https://treesoft.io/th/manual/payroll#group',
        },
        {
          module_id: 3,
          translate: 'apps.settings.permission.appid14-moduleid3',
          learn_more_link: 'https://treesoft.io/th/manual/payroll#condition',
        },
        {
          module_id: 4,
          translate: 'apps.settings.permission.appid14-moduleid4',
          learn_more_link: 'https://treesoft.io/th/manual/payroll#setting',
        },
      ],
    },
    {
      app_id: 12,
      translate: 'app.accounts',
      modules: [
        {
          module_id: 1,
          translate: 'apps.settings.permission.appid12-moduleid1',
          learn_more_link: 'https://treesoft.io/th/manual/accounting#overview',
        },
        {
          module_id: 2,
          translate: 'apps.settings.permission.appid12-moduleid2',
          learn_more_link: 'https://treesoft.io/th/manual/accounting#invoice',
        },
        {
          module_id: 3,
          translate: 'apps.settings.permission.appid12-moduleid3',
          learn_more_link: 'https://treesoft.io/th/manual/accounting#payment',
        },
        {
          module_id: 5,
          translate: 'apps.settings.permission.appid12-moduleid5',
          learn_more_link: 'https://treesoft.io/th/manual/accounting#receipt',
        },
        {
          module_id: 6,
          translate: 'apps.settings.permission.appid12-moduleid6',
          learn_more_link: 'https://treesoft.io/th/manual/accounting#journalentry',
        },
        {
          module_id: 7,
          translate: 'apps.settings.permission.appid12-moduleid7',
          learn_more_link: 'https://treesoft.io/th/manual/accounting#chartofaccount',
        },
        {
          module_id: 8,
          translate: 'apps.settings.permission.appid12-moduleid8',
          learn_more_link: 'https://treesoft.io/th/manual/accounting#tax',
        },
        {
          module_id: 4,
          translate: 'apps.settings.permission.appid12-moduleid4',
          learn_more_link: 'https://treesoft.io/th/manual/accounting#setting',
        },
      ],
    },
    {
      app_id: 13,
      translate: 'app.hrm',
      modules: [
        {
          module_id: 1,
          translate: 'apps.settings.permission.appid13-moduleid1',
          learn_more_link: 'https://treesoft.io/th/manual/hrm#employee',
        },
        {
          module_id: 2,
          translate: 'apps.settings.permission.appid13-moduleid2',
          learn_more_link: 'https://treesoft.io/th/manual/hrm#department',
        },
        {
          module_id: 3,
          translate: 'apps.settings.permission.appid13-moduleid3',
          learn_more_link: 'https://treesoft.io/th/manual/hrm#position',
        },
      ],
    },
    // {
    //   app_id: 7,
    //   translate: 'app.crm',
    //   modules: [],
    // },
    {
      app_id: 8,
      translate: 'app.reports',
      modules: [
        {
          module_id: 1,
          translate: 'apps.settings.permission.appid8-moduleid1',
          learn_more_link: 'https://treesoft.io/th/manual/report#income-statement',
        },
        {
          module_id: 2,
          translate: 'apps.settings.permission.appid8-moduleid2',
          learn_more_link: 'https://treesoft.io/th/manual/report#pos',
        },
        {
          module_id: 5,
          translate: 'apps.settings.permission.appid8-moduleid5',
          learn_more_link: 'https://treesoft.io/th/manual/report#purchase',
        },
        {
          module_id: 4,
          translate: 'apps.settings.permission.appid8-moduleid4',
          learn_more_link: 'https://treesoft.io/th/manual/report#expense',
        },
        {
          module_id: 3,
          translate: 'apps.settings.permission.appid8-moduleid3',
          learn_more_link: 'https://treesoft.io/th/manual/report#inventory',
        },
      ],
    },
    // {
    //   app_id: 9,
    //   translate: 'app.bi',
    //   modules: [],
    // },
    {
      app_id: 11,
      translate: 'app.contacts',
      modules: [
        {
          module_id: 1,
          translate: 'apps.settings.permission.appid11-moduleid1',
          learn_more_link: 'https://treesoft.io/th/manual/contact#list-all',
        },
        {
          module_id: 2,
          translate: 'apps.settings.permission.appid11-moduleid2',
          learn_more_link: 'https://treesoft.io/th/manual/contact#customer',
        },
        {
          module_id: 3,
          translate: 'apps.settings.permission.appid11-moduleid3',
          learn_more_link: 'https://treesoft.io/th/manual/contact#vendor',
        },
      ],
    },
  ],
}

// getters
const getters = {
  getApps: state => state.apps,
  getSidebar: state => state.sidebar,
  getLoading: state => state.loading,
  getError: state => state.error_message,
  getUIOptions: state => state.uiOptions,
  getNetworkStatus: state => state.network_status,
  getLang: state => state.lang,
  getAppInfo: (state) => (app_id) => {
    return state.apps.find(app => app.app_id == app_id)
  },
  getDefaultImages: (state) => state.defaultImages,
  getAppCurrent: state => state.current,
  getAppCurrentVersion: state => state.currentVersion,
  getAppLatestVersion: state => state.latestVersion,
  getAppPrev: state => state.prev,
  getSection: state => state.section,
  getDevice: state => document.querySelectorAll('body')[0].getAttribute('device'),
}

// mutations
const mutations = {
  setLoading (state, status) {
    state.loading = status
  },
  addLoadinglist (state, name) {
    state.loadinglist.push(name)
  },
  removeLoadinglist (state, name) {
    for (let i in state.loadinglist) {
      let _name = state.loadinglist[i]
      if (name == _name) {
        state.loadinglist.splice(i, 1)
      }
    }
  },
  setError (state, message) {
    state.error_message = message
  },
  setSection (state, section) {
    state.section = section
    state.error_message = null
  },
  setLang (state, lang) {
    state.lang = lang
    localStorage.setItem('lang', lang)
  },
  setSidebar (state, lists) {
    state.sidebar = lists
  },
  activeSidebar (state, opts) {
    if (opts.submenuAtIdx === undefined) {
      state.sidebar[opts.sidebarAtIdx].activeClass = 'active'
    } else {
      for (let i in state.sidebar[opts.sidebarAtIdx].submenus) {
        state.sidebar[opts.sidebarAtIdx].submenus[i].activeClass = ''
      }
      state.sidebar[opts.sidebarAtIdx].activeClass = 'opened'
      state.sidebar[opts.sidebarAtIdx].submenus[opts.submenuAtIdx].activeClass = 'active'
    }
  },
  setHeader (state, title) {
    state.header_title = title
  },
  setLastRouter (state, router) {
    state.last_router = router
  },
  updateUIOptions (state, opts) {
    if (!opts) opts = {}
    var newOptions = {}
    let uiOptions = LocalStorage.get('uiOptions') || {}
    // if found new option
    if (opts.sidebar) {
      newOptions['sidebar'] = opts.sidebar
    } else {
      // if found old option
      if (uiOptions.sidebar) {
        newOptions['sidebar'] = uiOptions.sidebar
      } else {
        // if not found set to default
        newOptions['sidebar'] = state.uiOptions.sidebar
      }
    }

    // if found new option
    if (opts.status) {
      if (opts.status.newproduct) {
        newOptions['status'] = {
          'newproduct': opts.status.newproduct,
        }
      }
    } else {
      // if found old option
      if (uiOptions.status) {
        newOptions['status'] = uiOptions.status
      } else {
        // if not found set to default
        newOptions['status'] = state.uiOptions.status
      }
    }

    LocalStorage.set('uiOptions', newOptions)

    state.uiOptions = newOptions
  },
  setNetworkStatus (state, bool) {
    state.network_status = bool
  },
  setAppCurrent (state, data) {
    state.current = data
  },
  setAppLatestVersion (state, version) {
    state.latestVersion = version
  },
  setAppPrev (state, data) {
    state.prev = data
  },
  setPagination (state, data) {
    state.pagination = transformPagination(data)
  },
}

// actions
const actions = {
  Loading: ({ commit }, status) => commit('setLoading', status),
  addLoadinglist: ({ commit }, name) => commit('addLoadinglist', name),
  removeLoadinglist: ({ commit }, name) => commit('removeLoadinglist', name),
  Error ({ commit }, error) {
    if (error) {
      console.error(error)
    }
    commit('setError', error)
  },
  setSection ({ commit }, section) {
    document.querySelector('body').setAttribute('section', section)
    commit('setSection', section)
  },
  switchLang ({ commit }, lang) {
    document.querySelector('html').setAttribute('lang', lang)
    commit('setLang', lang)
  },
  setSidebar ({ commit }, lists) {
    commit('setSidebar', lists)
  },
  activeSidebar ({ commit }, opts) {
    commit('activeSidebar', opts)
  },
  clearSidebar ({ commit }) {
    commit('setSidebar', [])
  },
  setHeader ({ commit }, title) {
    commit('setHeader', title)
  },
  setLastRouter ({ commit }, router) {
    commit('setLastRouter', router)
  },
  updateUIOptions ({ commit }, options) {
    commit('updateUIOptions', options)
  },
  setNetworkStatus ({ commit }, bool) {
    commit('setNetworkStatus', bool)
  },
  setAppCurrent ({ commit }, data) {
    commit('setAppCurrent', data)
  },
  setAppPrev ({ commit }, data) {
    commit('setAppPrev', data)
  },
  /**
   ** @param module (String) can be null we use cus let dev know where api call to module
   ** @param action (String) required action name in module
   */
  api ({ commit }, opts) {
    if (!opts.action.data) {
      return this.dispatch(opts.action.name)
    }
    return this.dispatch(opts.action.name, opts.action.data)
  },
  checkResponseApi ({ commit }, response) {
    if (response.data.access_token && response.data.refresh_token) {
      this.dispatch('updateToken', {
        'access_token': response.data.access_token,
        'refresh_token': response.data.refresh_token,
      })
    }

    if (!response.data.success) {
      if (response.data.status_message == 'auto_logout') {
        store.dispatch('Logout')
      }
    }

    return response
  },
  async getAppLatestVersion ({ commit }) {
    var result = null
    try {
      // clear error
      this.dispatch('Error', null)

      let response = await VersionService.getLatest()

      result = response.data

      if (result.success) {
        commit('setAppLatestVersion', lodash.get(result, 'data.version') || '0.0.1')
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  setPagination ({ commit }, data) {
    commit('setPagination', data)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/App.js